import type { ReactNode } from "react";
import { ArrowUpRight } from "lucide-react";
import "./hero-dashboard.css";

/** Hero copy and calls to action. The interactive conversation demo is passed in as children. */
export default function HeroDashboard({ children }: { children: ReactNode }) {
  return (
    <section className="hd-hero" aria-labelledby="hd-hero-title">
      <div className="hd-container">
        <h1 id="hd-hero-title" className="hd-title">Make every interaction feel remembered</h1>
        <p className="hd-sub">Dibs gives your team the full context of every person you serve, so people feel remembered, stay engaged and keep coming back.</p>
        <div className="hd-actions">
          <div className="hd-seen">
            <span>As seen on</span>
            <a href="https://www.agile.edu.sg/community.html" target="_blank" rel="noopener noreferrer" aria-label="Read about Dibs in the Agile community">
              <img src="/agile.png" alt="Agile" />
            </a>
            <a href="https://www.yagpb.sg/home" target="_blank" rel="noopener noreferrer" aria-label="Visit SG Youth Plan">
              <img src="/sg-youth-plan.png" alt="SG Youth Plan" />
            </a>
          </div>
          <a className="dh-button dh-button-primary" href="https://wa.me/6587169250" target="_blank" rel="noopener noreferrer">Book a demo <ArrowUpRight aria-hidden /></a>
        </div>

        <div className="hd-stage">{children}</div>
      </div>
    </section>
  );
}
